const synchronisationStatus = (statusCode) => {
  switch (statusCode) {
    case "requested":
      return { text: "Aangevraagd", className: "sync-status-requested" };
    case "accepted":
      return { text: "Geaccepteerd", className: "sync-status-accepted" };
    case "paired":
      return { text: "Gekoppeld", className: "sync-status-paired" };
    case "declined":
      return { text: "Geweigerd", className: "sync-status-declined" };
    case "deleted":
      return { text: "Verwijderd", className: "sync-status-deleted" };
    case "deleted-project":
      return {
        text: "Verwijderd door project",
        className: "sync-status-deleted",
      };
    default:
      return { text: "Onbekende status", className: "sync-status-deleted" };
  }
};

const synchronisationType = (type) => {
  switch (type) {
    case "MSIEffect":
      return "Meetstandaard effect";
    case "Effect":
      return "Effect";
    case "Output":
      return "Output";
    case "Question":
      return "Vraag";
    case "Targetgroup":
      return "Doelgroep";
    case "CustomEvent":
      return "Custom veld";
    case "Event":
      return "Activiteitveld";
    default:
      return "Onbekend";
  }
};

export { synchronisationStatus, synchronisationType };
